const getMembersStatuses = () => {
  return [
    { name: 'Invited', value: 'invited' },
    { name: 'Active', value: 'active' },
    { name: 'Finished', value: 'finished' },
    { name: 'Deleted', value: 'deleted' },
    { name: 'Blocked', value: 'blocked' },
  ]
}

export { getMembersStatuses }
